/**
 * Collection filtering, sorting and "load more" pagination.
 * The filter form works with JavaScript disabled (real <form method="get">,
 * a real "Apply" submit button), this only adds auto-submit-on-change and
 * the load-more enhancement on top.
 */
(function () {
  'use strict';

  function initFilters() {
    var form = document.querySelector('[data-collection-filter-form]');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = 'true';

    var applyButton = form.querySelector('[data-filter-apply]');
    if (applyButton) applyButton.hidden = true; // not needed once JS auto-submits

    form.querySelectorAll('[data-filter-input]').forEach(function (input) {
      input.addEventListener('change', window.Elara.debounce(function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }, 200));
    });

    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  function initLoadMore() {
    var grid = document.querySelector('[data-collection-grid]');
    var loadMoreButton = document.querySelector('[data-load-more]');
    var fallbackPagination = document.querySelector('[data-pagination-fallback]');
    if (!grid || !loadMoreButton) return;
    if (loadMoreButton.dataset.bound) return;
    loadMoreButton.dataset.bound = 'true';

    if (fallbackPagination) fallbackPagination.hidden = true;

    loadMoreButton.addEventListener('click', function () {
      var nextUrl = grid.dataset.nextUrl;
      if (!nextUrl) return;

      loadMoreButton.disabled = true;
      loadMoreButton.setAttribute('aria-busy', 'true');

      var fetchUrl = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=main';

      fetch(fetchUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-collection-grid]');
          if (!newGrid) return;

          Array.from(newGrid.children).forEach(function (card) {
            grid.appendChild(card);
          });

          grid.dataset.nextUrl = newGrid.dataset.nextUrl || '';
          if (!newGrid.dataset.nextUrl) {
            loadMoreButton.remove();
          }
        })
        .catch(function () {})
        .finally(function () {
          loadMoreButton.disabled = false;
          loadMoreButton.removeAttribute('aria-busy');
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFilters();
    initLoadMore();
  });
  document.addEventListener('elara:section:load', function () {
    initFilters();
    initLoadMore();
  });
})();
